import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCQGggJQm4xoiibAdMwIY4O30e5_RTbhJM",
  authDomain: "financeai-49fad.firebaseapp.com",
  projectId: "financeai-49fad",
  storageBucket: "financeai-49fad.firebasestorage.app",
  messagingSenderId: "208724937237",
  appId: "1:208724937237:web:c6e958ab041c161cdb5c1c"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
